const LOAD_DATA_MASTER_TIMEZONE         = 'LOAD_DATA_MASTER_TIMEZONE'
const LOAD_DATA_MASTER_TIMEZONE_SUCCESS = 'LOAD_DATA_MASTER_TIMEZONE_SUCCESS'
const LOAD_DATA_MASTER_TIMEZONE_FAILED  = 'LOAD_DATA_MASTER_TIMEZONE_FAILED'
const UNMOUNT_DATA_MASTER_TIMEZONE      = 'UNMOUNT_DATA_MASTER_TIMEZONE'

const initialState = {
  loading: true,
  data: null,
  message: null,
  meta: null
}

const timezoneReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DATA_MASTER_TIMEZONE:
      return {
        ...state,
        loading: true,
        data: null,
        meta: null
      }
    case LOAD_DATA_MASTER_TIMEZONE_SUCCESS:
      return {
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        meta: action.payload.meta
      }
    case LOAD_DATA_MASTER_TIMEZONE_FAILED:
      return {
        ...state, 
        loading: false,
        data: null,
        message: 'FAILED',
        meta: null
      }
    case UNMOUNT_DATA_MASTER_TIMEZONE:
      return { 
        ...state, 
        loading: true,
        data: null,
        meta: null
      }
    default:
      return state
  }
}
export default timezoneReducer